export const Loan_Variants = {
  TERM: "term",
  FLEXI: "flexi-loan",
  HYBRID: "hybrid",
  HOME_LOAN: "home-loan",
  EMI_HOLIDAY: "emi-holiday",
  PRINCIPAL_MORAT: "principal-morat",
  MF_LOAN: "mf-loan",
  NORMAL_TERM_LOAN: "Normal term loan",
  EMI_HOLIDAY_INSERT: "EMI Holiday",
  PRINCIPAL_MORAT_INSERT: "Principle MORAT",
  EMI_LITE: "emi-lite",
};

export const Loan_Type = {
  BLSE: "BLSE",
  BL: "BL",
  PL: "PL",
  HL: "HL",
  ZCUC: "ZCUC",
  ZBT: "ZBT",
  ZLC: "ZLC",
  DL: "DL",
  LFL: "LFL",
  CA: "CA",
  HLBT: "HLBT",
  LAS: "LAS",
  LAMF: "LAMF",
  LAP: "LAP",
  LAPBT: "LAPBT",
  MEF: "MEF",
  RMEF: "REFIN",
  MEFBT: "BT",
  IEF: "IEF",
  MFL: "MFL",
  LAIP: "LAIP",
  LAB: "LAB",
  TWL: "TWL",
  NCL: "NCL",
  NTL: "NTL",
  TF: "TF",
  BLSEBT: "BTBLSE",
  ESOP: "ESOP",
  DC: "DC",
};

export const PLCSOfferDisplayName = [
  "PLCS GIN",
  "PMG GIN",
  "STP",
  "PLCS Pre approved",
  "PPL",
  "PLPPL",
  "PROF PPL",
  "Full Underwriting",
];

export const BLSEIcorsProduct = {
  LAP_SME_BLSE: "LAP_SME_BLSE",
  LAP_SME_PLSE: "LAP_SME_PLSE",
};

export const HLPDPConstants = {
  FRESH: "FRESH",
  BT: "BT",
  BALANCE_TRANSFER: "balance-transfer",
  LOAN_REDIRECT: "loanRedirect",
  AFHO: "AFHO",
  BHFL: "BHFL",
  AFFORDABLE_HOME_LOAN: "affordable-home-loan",
  LAPSME: "LAP,SME",
  INPUT_LOAN_AMOUNT: "inputHlLoanAmount",
  notServicable: "not serviceable",
};
export const ICORS_ONLY_LOAN_TYPE = {
  LAP: "LAP",
  LAPBT: "LAPBT",
  BLSE: "BLSE",
  BLSEBT: "BLSEBT",
};

export const HLPDPIcorsConstants = {
  BHFL: "bhfl",
  HOME_LOAN: "Home Loan",
  INSTA_HOME_LOAN_BT: "Insta Home Loan-Balance transfer",
  HOME_LOAN_BT: "Home Loan - Balance transfer",
  AFFORDABLE_HOME_LOAN: "Affordable Home Loan",
  SME: "sme",
  NEW: "New",
};

export const HLDynamicRedirectConstants = {
  HLFRESH: "HL_FRESH",
  HLBT: "HL_BT",
  AFHOFRESH: "AFHO_FRESH",
  AFHOBT: "AFHO_BT",
};

export const GinOfferDisplayNames = ["SALPL GIN", "RSL Get Now", "PLCS GIN", "PMG GIN", "STP"];

export const GinOfferJourneyNames = ["PLCS_GIN", "RPL_STP", "SAL_GIN", "RSL_LINE"];

export const RuralOfferDisplayName = [
  "RSL Get Now",
  "RCD_RSL Preapproved",
  "RCD RSL Prequalified",
  "RSL Get Now Field",
  "RSL RCD SDK PA",
  "RCD RSL Preapproved",
  "STP",
  "Full Underwriting",
  "RPL",
  "RPPL",
];

export const RuralOfferJourneyNames = [
  "RSL_LINE",
  "RSL_PREAPPROVED",
  "RSL_NO_OFFER",
  "RPL_STP",
  "RPL_FULL_UW",
  "RPPL_FUW",
];

export const PLCSGINOfferDisplayNameForPL = [
  "PLCS GIN",
  "STP",
  "PLCS Pre approved",
  "Full Underwriting",
  "SALPL GIN",
  "RSL Get Now",
  "SALPL LINE pre-approved",
  "SALPL Pre approved",
  "RCD_RSL Preapproved",
  "RCD RSL Prequalified",
  "RSL Get Now Field",
  "RSL RCD SDK PA",
  "SAL PL Preferred",
  "RCD RSL Preapproved",
  "PLTHT High Ticket",
  "PROF SAL PL",
];

export const RPLOfferDisplayName = ["Full Underwriting", "STP"];

export const employmentTypes = {
  SAL: "SALARIED",
};

export const Tenure_Type = {
  RURAL: "RURAL",
  URBAN: "URBAN",
  GIN: "GIN",
};

const isHindiPage = () =>
  typeof window !== "undefined" &&
  (location?.pathname.includes("/hi") || location?.pathname.includes("/hindi"));

const hindiPage = isHindiPage();

const basePath = hindiPage ? "/hindi" : "";

export const URL_CONSTANTS = {
  PL: `${basePath}/personal-loan`,
  IPL: `${basePath}/insta-personal-loan`,
  PL_APP: `${basePath}/app-v1/personal-loan`,
  IPL_APP: `${basePath}/app-v1/insta-personal-loan`,
  ThreePl: `${basePath}/3-personal-loan-variants`,
  FD: `${basePath}/investments/fixed-deposit`,
  SDP: `${basePath}/investments/systematic-deposit-plan`,
  CMLPPL: `${basePath}/personal-loan-for-salaried-individuals-affinity`,
  CMLPIPL: `${basePath}/insta-personal-loan-offers-footprints`,
  CMLP3PL: `${basePath}/3-personal-loan-variants-offers`,
} as const;

export const DPAOP_URL_CONSTANTS = {
  PL: `${basePath}/personal-loan-new`,
  IPL: `${basePath}/insta-personal-loan-new`,
  PL_APP: `${basePath}/app-v2/personal-loan`,
  IPL_APP: `${basePath}/app-v2/insta-personal-loan`,
};

export const MefJourneyType = {
  MEF_BE: "Buy Equipment",
  MEF_RE: "Refinance Equipment",
  MEF_BT: "Balance Transfer",
};

export const ProdCodes = {
  PEMFR: {
    value: "PEMFR",
  },
} as const;

export const PL_SUBCATEGORY_CONSTANTS = [
  "Personal Loan",
  "Personal Loan Default",
  "Personal Loan Icors",
];
export const initialMonthNumber = "1";

export const BUSINESS_TO_EVENTNAME_MAP: { [key: string]: string } = {
  PL: "B2C_OFFER_VIEW",
  PRO: "PDP_Details",
  PSBL: "PDP_Details",
  BLSE: "PDP_Details",
  ZCUC: "PDP_Details",
  HL: "HL_PDP",
  FD: "Investment Details",
  SDP: "Investment Details",
};

export const B2C_DOACVALIDATE_API_VERSION = "v2";

//DPAOP3
export const PL_JOURNEY_NAME = {
  PLCS: "DEFAULT_JOURNEY_NAME",
  SALPL: "SAL_NO_OFFER",
};
